import { defineMessages } from 'react-intl';

export const RatingsOverviewCardMessages = defineMessages({
  header: {
    id: 'customerRatings.ratingsOverviewCard.header',
    defaultMessage: 'Bewertungsübersicht',
  },
});
